import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCampanha } from 'campanha/src/store/campanhaReducer';
import { Container } from "base/src/components/Basic/Container/container"
import { useEffect } from 'react';
import { StatusRoute } from 'base/src/store/util/action/utilAction';
import { UsuarioSistemaPerfilEnum } from 'domain/types/usuarioSistemaPerfil/usuarioSistemaPerfilEnum';
import { useCampanhaId } from '../../hooks/useCampanhaId';
import { styled } from 'styled-components';
import { Icon } from '@iconify/react';

const connector = connectUtil(
	(state: RootStateCampanha) => ({
		usuarioSistemaPerfil: state.UsuarioSistemaPerfilReducer.usuarioSistemaPerfil
	}),
	{ StatusRoute }
);

export interface ViewContainerProps extends PropsFromRedux<typeof connector> {
	children?: React.ReactNode;
}

function ViewContainer(props: ViewContainerProps) {
	const campanhaId = useCampanhaId();

	useEffect(() => {
		if (props.usuarioSistemaPerfil == null) { return }

		if (props.usuarioSistemaPerfil && props.usuarioSistemaPerfil.find(u =>
			u.PerfilID === UsuarioSistemaPerfilEnum.AdministradorDeCarteira
		)) {
			props.StatusRoute("pagarPedido", true);
			props.StatusRoute("aprovarPedido", true);
			props.StatusRoute("gerarLote", true);
			props.StatusRoute("notaRepasse", true);
		} else {
			props.StatusRoute("pagarPedido", false);
			props.StatusRoute("aprovarPedido", false);
			props.StatusRoute("gerarLote", false);
			props.StatusRoute("notaRepasse", false);
		}
	}, [props.usuarioSistemaPerfil]);

	if (!campanhaId) {
		return (
			<MissingParamPage>
				<MissingParamCard>
					<Icon icon="ph:warning-circle" height={64} color="#f59e0b" />
					<MissingParamTitle>Parâmetro obrigatório ausente</MissingParamTitle>
					<MissingParamMessage>
						O parâmetro <strong>campanhaId</strong> não foi encontrado na URL nem nos claims do token de acesso.
						Verifique o link utilizado ou entre em contato com o administrador do sistema.
					</MissingParamMessage>
				</MissingParamCard>
			</MissingParamPage>
		);
	}

	return (
		<Container>
			{props.children}
		</Container>
	);
}

export default connector(ViewContainer);

const MissingParamPage = styled.div`
	height: 90vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
`;

const MissingParamCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	padding: 48px;
	border-radius: 20px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
	max-width: 480px;
	text-align: center;
`;

const MissingParamTitle = styled.h2`
	color: #f59e0b;
	font-size: 22px;
	font-weight: 700;
	margin: 0;
`;

const MissingParamMessage = styled.p`
	color: #374151;
	font-size: 15px;
	line-height: 1.6;
	margin: 0;
`;
